module.exports = __webpack_public_path__ + "media/images/icon-facebook-s-38797597d4c778a16badec1c81909ad6.svg";